import React, { useMemo } from 'react';
import { formatDate, humanDataLimit, humanMinutes, pubHidden, yesNo } from '../../util/araknerdlib';

const speedText = (p) => {
  if (p?.download_mbps || p?.upload_mbps) {
    const d = p.download_mbps ? `${p.download_mbps} Mbps ↓` : '—';
    const u = p.upload_mbps ? ` / ${p.upload_mbps} Mbps ↑` : '';
    return `${d}${u}`;
  }
  return p?.mikrotik_rate_limit || null; // e.g., "2M/1M"
};

const PropertyList = ({ plan = {} }) => {
  // Build key-value pairs in the order you like
  const items = useMemo(() => {
    const list = [
      ['type', plan.plan_type],
      ['duration', humanMinutes(plan.duration_minutes)],
      ['visibility', pubHidden(plan.is_visible)],
      ['code', plan.plan_code],
      ['name', plan.name],
      ['description', plan.description],
      ['status', plan.status],
      ['data_limit', humanDataLimit(plan.data_limit_mb)],
      ['is_unlimited', String(plan.is_unlimited) === '1' ? true : false],
      ['speed', speedText(plan)],
      ['valid_days', plan.valid_days],
      ['notes', plan.notes],
      ['created_at', plan.created_at ? formatDate(plan.created_at) : null],
      ['updated_at', plan.updated_at ? formatDate(plan.updated_at) : null],
    ];
    // keep only non-empty
    return list.filter(([_, v]) => v !== null && v !== '' && v !== undefined);
  }, [plan]);

  const renderVal = (v) => {
    if (typeof v === 'boolean') return <span className="t-bool">{String(v)}</span>;
    if (typeof v === 'number')  return <span className="t-num">{v}</span>;
    // try number-like strings (e.g., "1440")
    if (typeof v === 'string' && v.trim() !== '' && !Number.isNaN(Number(v)) && v === String(Number(v))) {
      return <span className="t-num">{v}</span>;
    }
    // null token (shouldn’t reach here due to filter, but safe)
    if (v === null) return <span className="t-null">null</span>;
    // default: quoted string
    return <span className="t-str">"{v}"</span>;
  };

  return (
    <div className="code-kv">
      <div className="code-kv__brace">&nbsp;</div>
      <ul className="code-kv__list">
        {items.map(([k, v], idx) => (
          <li key={k}>
            <span className="t-key">{k}</span>
            <span className="t-p">: </span>
            {renderVal(v)}
            <span className="t-p">{idx < items.length - 1 ? ',' : ''}</span>
          </li>
        ))}
      </ul>
      <div className="code-kv__brace">&nbsp;</div>
    </div>
  );
};

export default PropertyList;
